import React, {useState} from 'react'
import PropTypes from 'prop-types'
import FollowersGameOption from './FollowersGameOption'

export default function FollowersGameRound(props) {

	const [choices, setChoices] = useState(props.data.choices);
	const [winner, setWinner] = useState(props.data.winner);
	const [winnerFollowers, setWinnerFollowers] = useState(props.data.winner_followers)

	const answerChosen = (event, name) => {
		if(name == winner) {
			alert("Correct")
		}
		else {
			alert("Incorrect. Answer: " + name)
		}
		props.roundFinished();
	}

	const getOptions = () => {
		var options = []

		for(let[key, value] of choices) {
			options.push(<FollowersGameOption key={key} name={key} handle={value} answerChosen={answerChosen}/>)
		}

		return options;
	}



	return (
		<>
			{getOptions}
		</>
	)
}

FollowersGameRound.propTypes = {
	data: PropTypes.object.isRequired,
	roundFinished: PropTypes.func.isRequired
}
